import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { IAnnouncement } from '../../../types/website-builder/announcement';
import { EmptyRowService } from '../../../services/empty-row.service';
import { UrlService } from '../../../services/url.service';
import { AppModalService } from '../../../services/app-modal.service';
import { AnnouncementsViewModalComponent } from '../announcements-view-modal/announcements-view-modal.component';
import { AccountPermissionsService } from '../../../services/account-permissions.service';
import { Permission } from '../../../types/api-response/auth/permission';
import { IAnnouncementRules } from '../../../types/announcement-rules';

@Component({
  selector: 'announcements-list',
  templateUrl: './announcements-list.component.html',
  styleUrls: ['./announcements-list.component.scss']
})
export class AnnouncementsListComponent implements OnInit {

  tableColumns: {
    title: string,
    key: keyof IAnnouncement | string,
    sortable: boolean,
    isVisible: boolean,
    cellTpl?: string
  }[] = [];

  @ViewChild('scrollWrapper') scrollWrapper: ElementRef;

  @Input() set announcements(announcements: IAnnouncement[]) {
    this.announcementsList = announcements;
    this.scrollToTop();
  }

  @Input() isServiceUnavailable: boolean = false;
  @Input() spinnerShow: boolean = false;
  @Input() rules: IAnnouncementRules;

  @Output() onCreateItem: EventEmitter<any> = new EventEmitter();
  @Output() onRemoveItem: EventEmitter<string> = new EventEmitter();

  announcementsList: IAnnouncement[];

  permission: typeof Permission = Permission;

  corporationPermission: { [key: number]: Set<Permission> };

  constructor(
      public emptyRowService: EmptyRowService,
      public urlService: UrlService,
      private modalService: AppModalService,
      private account: AccountPermissionsService,
  ) { }

  ngOnInit() {
    this.corporationPermission = this.account.getCorporationServicePermissions('announcements');
    this.setTableColumns();
  }

  /**
   * Define table column params
   */
  private setTableColumns() {
    const corporationNumberIds = Object.getOwnPropertyNames(this.corporationPermission);
    const isCorporationColumnVisible = this.account.isUserAdmin() || corporationNumberIds.length > 1;

    this.tableColumns = [
      { title: 'Corporation', key: 'corporationNumberName', isVisible: isCorporationColumnVisible, sortable: true},
      { title: 'Subject', key: 'title', isVisible: true, sortable: true},
      { title: 'Created On', key: 'createdAt', isVisible: true, sortable: true},
      { title: 'Created By', key: 'createdBy', isVisible: true, sortable: true, cellTpl: 'createdByCell'},
      { title: 'Status', key: 'status', isVisible: true, sortable: false},
      { title: 'From', key: 'periodBegin', isVisible: true, sortable: true},
      { title: 'To', key: 'periodEnd', isVisible: true, sortable: true},
      { title: 'Action', key: 'action', isVisible: true, sortable: false},
    ];
  }

  orderBy(orderBy: keyof IAnnouncement | string, $event) {
    if (orderBy && this.announcementsList.length > 2) {
      this.urlService.orderBy(orderBy, $event);
    }
  }

  /**
   * View notice in modal
   * @param noticeId
   */
  viewNotice(noticeId: string) {
    this.modalService.open(AnnouncementsViewModalComponent, {noticeId});
  }

  /**
   * Remove notice
   */
  removeNotice(noticeId: string) {
    this.onRemoveItem.emit(noticeId);
  }

  /**
   * Checks permission for corporation number ID
   */
  isActionAllowed(corporationNumberId, permissionType: Permission|Permission[]): boolean {
    if(this.account.isUserAdmin()) {
      return true;
    }

    const permissionsToCheck = Array.isArray(permissionType) ? permissionType : [permissionType];

    if(!this.corporationPermission || !this.corporationPermission[corporationNumberId]) {
      return false;
    }

    return permissionsToCheck.reduce((isPevAllowed, permission) => isPevAllowed && this.corporationPermission[corporationNumberId].has(permission), true);
  }

  /**
   * Scroll list to top
   */
  private scrollToTop() {
    this.scrollWrapper.nativeElement.scrollTo(0, 0);
  }

}



// WEBPACK FOOTER //
// /app/src/app/views/announcements/announcements-list/announcements-list.component.ts